import React, { useEffect, useState} from 'react';
import { NavLink } from 'react-router-dom/cjs/react-router-dom';
import NomLists from '../components/nomLists';

import './nom.css';


// const BOOKS = [
//     {id: '1', title: 'Алтан Ганжуур', type: 'Хөлгөн судар', description: 'Хамаг амьтаны тус хийгээд амар амгалангийн тухайд', price: '20000'},
//     {id: '2', title: 'Жадонба', type: 'Хөлгөн судар', description: 'Хамаг амьтаны тус хийгээд амар амгалангийн тухайд', price: '10000'},
//     {id: '3', title: 'Сундуй', type: 'Хөлгөн судар', description: 'Хамаг амьтаны тус хийгээд амар амгалангийн тухайд', price: '15000'},
//     {id: '4', title: 'Улаан Юм', type: 'Хөлгөн судар', description: 'Хамаг амьтаны тус хийгээд амар амгалангийн тухайд', price: '8000'},
//     {id: '5', title: 'Дорж Зодба', type: 'Хөлгөн судар', description: 'Хамаг амьтаны тус хийгээд амар амгалангийн тухайд', price: '12000'},
//     {id: '6', title: 'Данжуур', type: 'Хөлгөн судар', description: 'Хамаг амьтаны тус хийгээд амар амгалангийн тухайд', price: '11000'},
//     {id: '7', title: 'Нити', type: 'Хөлгөн судар', description: 'Хамаг амьтаны тус хийгээд амар амгалангийн тухайд', price: '16000'},
  
//   ]
  


const Nom = () => {
  const [books, setBooks] = useState([]);

  

  useEffect(() => {
    const fetchBooks = async () => {
      try {
        const result = await fetch(process.env.REACT_APP_BACKEND_URL + '/books');
        const resultData = await result.json();
        setBooks(resultData);
        console.log('Nomnuud: ',resultData)
      } catch (err) {
        console.log('This error from frontend: ', err.message)
      }
    }
   
    fetchBooks();
  }, []);

 

  return (
    <main className="nom-pg-container">
      <h1>Айлтгал номнууд</h1>
      <div className='nom-pg-controller'>
      
        <section className='nom-pg-sec1'>
          <div className='nom-links-container'>
            <h3>Судрын төрөл</h3>
            <div className='nom-links-controller'>
              <NavLink to='/nom' id='navLink' >Бүх Айлтгал</NavLink>
              <NavLink to='/nom' id='navLink' >Их хөлгөн судрууд </NavLink>
              <NavLink to='/nom' id='navLink'>Чогууд</NavLink>
              <NavLink to='/nom' id='navLink' >Сахиусны тахилга</NavLink>
              <NavLink to='/nom' id='navLink' >Заслын номнууд</NavLink>
            </div>
          </div>
        </section>

        <section className='nom-pg-sec2'>
          <div className='nom-books-container'>
            <NomLists book={books}/>
          </div>    
        </section>

      </div>     
    </main>
  )
}
export default Nom;
